import { Avatar, Typography } from '@maas-components/core'
import styled from 'styled-components'

export const StyledAvatar = styled(Avatar)`
  && {
    background-color: ${({ color }) => color || '#B8DEFF'};
    color: ${({ theme }) => theme.palette.primary.main};
    width: ${({ theme }) => theme.spacing(4)}px;
    height: ${({ theme }) => theme.spacing(4)}px;
    font-size: ${({ theme }) => theme.typography.pxToRem(20)};
  }
`

export const StyledLabel = styled(Typography)`
  font-size: ${({ theme }) => theme.typography.pxToRem(20)};
`
